import { io, Socket } from 'socket.io-client';

// El socket vive en la raiz del dominio del backend (path /socket.io), sin el sufijo /api.
const API_URL = process.env.REACT_APP_API_URL || '';
const SOCKET_URL = API_URL
  ? API_URL.replace(/\/api\/?$/, '')
  : window.location.origin;

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1500,
      reconnectionDelayMax: 5000,
    });
  }
  return socket;
}
